import React from 'react';
import ReactDOM from 'react-dom';
import MainContainer from './modules/common/containers/MainContainer';

ReactDOM.render(<MainContainer />, document.getElementById('root'));
